import React, { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    lang,
    toggleLang
  } = useLanguage();
  const t = translations[lang].nav;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.properties,
    href: '#properties'
  }, {
    name: t.about,
    href: '#about'
  }, {
    name: t.services,
    href: '#services'
  }, {
    name: t.neighborhoods,
    href: '#neighborhoods'
  }, {
    name: t.contact,
    href: '#contact'
  }];
  const scrollToSection = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'}`} data-id="element-182">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-183">
          {/* Left: Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-184">
            <h1 className={`font-serif-display text-2xl tracking-widest uppercase ${isScrolled ? 'text-[#1a1a1a]' : 'text-white'}`} data-id="element-185">
              Cenia Badillo
            </h1>
          </div>

          {/* Center: Desktop Links */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-186">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className={`text-sm tracking-widest uppercase transition-colors duration-300 ${isScrolled ? 'text-[#1a1a1a] hover:text-[#c9a96e]' : 'text-white hover:text-[#c9a96e]'}`} data-id="element-187">
                {link.name}
              </button>)}
          </div>

          {/* Right: Phone, Lang Toggle, Mobile Menu Toggle */}
          <div className="flex items-center space-x-6" data-id="element-188">
            <button onClick={toggleLang} className={`text-sm font-medium tracking-widest transition-colors ${isScrolled ? 'text-[#1a1a1a] hover:text-[#c9a96e]' : 'text-white hover:text-[#c9a96e]'}`} data-id="element-189">
              {lang === 'en' ? 'ES' : 'EN'}
            </button>

            <a href="tel:6513872889" className={`hidden md:inline-block px-6 py-2 border transition-all duration-300 text-sm tracking-widest ${isScrolled ? 'border-[#c9a96e] text-[#c9a96e] hover:bg-[#c9a96e] hover:text-white' : 'border-[#c9a96e] text-white hover:bg-[#c9a96e] hover:border-transparent'}`} data-id="element-190">
              651.387.2889
            </a>

            <button className={`lg:hidden ${isScrolled ? 'text-[#1a1a1a]' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(true)} data-id="element-191">
              <Menu size={28} strokeWidth={1.5} data-id="element-192" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-193">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: '-100%'
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: '-100%'
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed inset-0 z-[60] bg-[#1a1a1a] text-white flex flex-col" data-id="element-194">
            <div className="flex justify-between items-center p-6 border-b border-white/10" data-id="element-195">
              <h1 className="font-serif-display text-2xl tracking-widest uppercase text-white" data-id="element-196">
                Menu
              </h1>
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-[#c9a96e] transition-colors" data-id="element-197">
                <X size={32} strokeWidth={1.5} data-id="element-198" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto py-12 px-6 flex flex-col space-y-8" data-id="element-199">
              {navLinks.map((link, i) => <motion.button key={link.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1 + 0.2
          }} onClick={() => scrollToSection(link.href)} className="text-left font-serif-display text-4xl tracking-wider hover:text-[#c9a96e] transition-colors" data-id="element-200">
                  {link.name}
                </motion.button>)}

              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.8
          }} className="pt-12 mt-auto border-t border-white/10 flex flex-col space-y-6" data-id="element-201">
                <a href="tel:6513872889" className="text-[#c9a96e] text-xl tracking-widest" data-id="element-202">
                  651.387.2889
                </a>
                <button onClick={toggleLang} className="text-left text-sm tracking-widest uppercase text-white/70 hover:text-white" data-id="element-203">
                  Switch to {lang === 'en' ? 'Spanish' : 'English'}
                </button>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};